import React from 'react';
import {
  createStyles,
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
  TextareaAutosize,
  TextareaAutosizeProps
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {
  FONT_PRIMARY_COLOR,
  INPUT_BORDER_COLOR,
  INPUT_LABEL_COLOR
} from 'src/style/variable';

interface ITextAreaInput extends TextareaAutosizeProps {
  label?: string;
  error?: Record<string, any>;
  formControlClass?: string;
}

export const useStyles = makeStyles(() =>
  createStyles({
    minutesMenu: {
      '& .MuiPopover-paper': {
        padding: '1rem'
      }
    },
    textareaAutosize: {
      color: FONT_PRIMARY_COLOR,
      opacity: '1',
      marginTop: 0,
      borderColor: INPUT_BORDER_COLOR,
      // @ts-ignore
      overflowY: 'auto !important'
    },
    error: {
      borderColor: '#e53935'
    },
    formControl: {
      paddingBottom: 0,
      marginBottom: 0
    }
  })
);

const TextAreaInput = (props: ITextAreaInput): JSX.Element => {
  const {label, error, className = '', formControlClass = '', ...rest} = props;
  const classes = useStyles();
  const {t} = useTranslation();
  return (
    <FormControl
      error={!!error}
      className={`${classes.formControl} ${formControlClass}`}
      fullWidth
      variant="standard"
      required={rest.required}>
      {label && (
        <InputLabel
          style={{
            position: 'static',
            transform: 'none',
            marginBottom: '0.5rem',
            fontSize: '1.1rem',
            color: INPUT_LABEL_COLOR
          }}
          shrink>
          {label}
        </InputLabel>
      )}
      <TextareaAutosize
        rowsMax={10}
        rows={4}
        className={`app-text-area ${classes.textareaAutosize} ${
          error ? classes.error : ''
        } ${className}`}
        {...rest}
      />
      {error && <FormHelperText>{t(error.message)}</FormHelperText>}
    </FormControl>
  );
};

export default TextAreaInput;
